import {Component} from 'preact';

require('../styles/Home.scss')

export class Success extends Component {
    constructor() {
        super();

    }

    render(props, state) {
        return <div className='container'>
            <div className='header'>
                <div className='header-title'>
                </div>
            </div>
            <div className='divider-50'/>
            <div className='content-container'>
                <div className='center'>
                    L’URL a bien été configurée. Vous serez redirigé vers la page au prochain scan du QR code.
                </div>
                <div className='divider-50'/>
                <div className='center text-center'>
                    <img src='../assets/images/check_circle.svg' height='120'/>
                </div>
            </div>
        </div>;
    }
}
